import React from 'react';

import type {
  ReportsFilterOptionGroup,
  ReportsFilterSelection,
} from 'components/Reports/hooks/useReportsFilterOptions';

import StylishNewSelect from 'components/DesignSystems/New/StylishNewSelect';

type ReportsFilterBarProps = {
  groupedOptions: ReportsFilterOptionGroup[];
  selectedFilter: ReportsFilterSelection | null;
  onSelectedFilterChange: (
    selectedFilter: ReportsFilterSelection | null
  ) => void;
  disableFilter?: boolean;
};

const ReportsFilterBar: React.FC<ReportsFilterBarProps> = ({
  groupedOptions,
  selectedFilter,
  onSelectedFilterChange,
  disableFilter = false,
}) => {
  const filterSelectId = 'reports-filter-select';

  return (
    <div className="reports-filter-bar">
      <div className="reports-filter-bar__controls">
        <div className="reports-filter-bar__filter-control">
          <div className="reports-filter-bar__select-wrapper">
            <label className="visually-hidden" htmlFor={filterSelectId}>
              Filter reports by area of responsibility or incident
            </label>
            <StylishNewSelect
              options={groupedOptions}
              value={selectedFilter}
              onChange={(option: ReportsFilterSelection | null) =>
                onSelectedFilterChange(option)
              }
              inputId={filterSelectId}
              isClearable
              isSearchable
              placeholder="Filter AOR/Incident..."
              classes="sml"
              isDisabled={disableFilter}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReportsFilterBar;
